import React, { useState } from "react";
import { Button } from "@/components/ui";
import { Copy, Check } from "lucide-react";
import { cn } from "@/lib/utils";

/** Copy button beside the link itself, as Form Links and a response's details show it. */
export function CopyLinkButton({ url }: { url?: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (url) {
      navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <div className="flex items-center gap-2.5 max-w-[380px]">
      <Button
        variant={copied ? "default" : "outline"}
        size="xs"
        onClick={handleCopy}
        className={cn(
          "h-7 text-[10px] px-2.5 rounded-lg flex items-center gap-1 transition-all duration-150 select-none shrink-0",
          copied ? "bg-emerald-600 border-emerald-600 text-white hover:bg-emerald-700 animate-pulse" : ""
        )}
      >
        {copied ? <Check className="size-3 shrink-0" /> : <Copy className="size-3 shrink-0" />}
        {copied ? "Copied" : "Copy"}
      </Button>
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-primary hover:underline font-mono truncate select-all flex-1"
          title={url}
        >
          {url}
        </a>
      ) : (
        <span className="text-slate-400 font-sans text-xs">-</span>
      )}
    </div>
  );
}
